export const SET_LANGUAGE = "SET_LANGUAGE";

export function setLanguage(codeLang) {
  return {
    type: SET_LANGUAGE,
    codeLang
  };
}